import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

export var form =
{
	model: 'product',

	form_title: 'Produit',

	fields:
	{
		'name':
		{
			label: 'Nom',
			front_indicator: true
		},

		'send_notifications':
		{
			label: 'Envoyer une notification',
			type: 'checkbox'
		},

		'images':
		{
			type: 'image',
			label: 'Images',
			multiple: true,
			front_indicator: true
		},

		'videos':
		{
			label: 'Vidéos YouTube',
			youtube: true,
			repeatable: true,
			front_indicator: true
		},

		'description':
		{
			label: 'Description',
			type: 'editor',
			front_indicator: true,
			images: false,
			color: true,

			'col-size': '12'
		},

		'places':
		{
			label: 'Lieu(x)',
			repeatable: true,
			front_indicator: true
		},

		'client_public':
		{
			label: 'Public',
			front_indicator: true
		},

		'theme':
		{
			label: 'Thème',
			type: 'text',
			front_indicator: true
		},

		'is_individuel':
		{
			label: 'Produit individuel',
			type: 'checkbox',

			'col-size': '3'
		}
	},

	'create_label': 'Créer ce produit',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce produit&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['product[name]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (product)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau produit <strong> { product.name } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/gestion-du-catalogue/produits/' + product.id }>
						Voir le produit
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export var list =
{
	model        : 'product',
	title        : 'Liste des produits',
	link         : '/gestion-du-catalogue/produits',
	header_map:
	{
		'Image'           : 'images.url',
		'Nom'             : 'name',
		'Prix'            : 'price',
		'Description'     : 'short_description',
		'Date de création': 'createdAt'
	},
	image_fields : ['Image'],
	date_fields  : ['Date de création'],
	row_link_base: '/gestion-du-catalogue/produits/',
	searched_prop: 'name',
	field_hook:
	{
		Prix: function (value)
		{
			return value + ' €';
		}
	}
};

var config = mergeDeep({ }, form);

mergeDeep(config, list);

export default config